export default __webpack_public_path__ + "static/sign-in-news-feed-a7319415ab6c33e5cb10ec28d5c28ea5.png";